"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ["Yes", "No", "Unknown"];
exports.default = _default;
//# sourceMappingURL=if_project_do_you_have_budget.js.map